import ImagePreviewContainer from "./ImagePreviewContainer";

export default ImagePreviewContainer;
